;(function ($) {
  "use strict";
  $(document).ready(function () {
    $('html').removeClass('no-js');
  });

  $(window).on('load', function () {
    $('body').removeClass('preload');
  });
})(jQuery);
